import BlockedMonths from "components/BlockedMonths/BlockedMonths";


const BlockedMonthsPage: React.FC = () => {
  return <BlockedMonths />;
};

export default BlockedMonthsPage;